const initialState = {
   settingsData: {},
   isFetching: true,
};

export default initialState;
